export default {
  incidentReports: 'INCIDENT_REPORTS',
  incidentReport: 'INCIDENT_REPORT',
  createIncidentReport: 'CREATE_INCIDENT_REPORT',
  editIncidentReport: 'EDIT_INCIDENT_REPORT',
  deleteIncidentReport: 'DELETE_INCIDENT_REPORT',
  reportLink: 'REPORT_LINK',
};
